/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingNativeDetailsBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return SecurityFindingNativeDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingNativeDetailsBase>): SecurityFindingNativeDetailsBase {
        let obj = Object.assign(new SecurityFindingNativeDetailsBase(), model);
        SecurityFindingNativeDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingNativeDetailsBase>): SecurityFindingNativeDetailsBase {
        if (!model) return null;
        return SecurityFindingNativeDetailsBase.newInstance(<SecurityFindingNativeDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingNativeDetailsBase) {
        if (!obj) return;

        models.SecurityFindingNativeDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingNativeDetailsBase): boolean {
        switch (obj.__type)
        {
            case "SecurityFindingNativeDetailsBaseForCloud":
                Object.setPrototypeOf(obj, models.SecurityFindingNativeDetailsBaseForCloud.prototype);
                break;
            case "SecurityFindingNativeDetailsBaseForContainer":
                Object.setPrototypeOf(obj, models.SecurityFindingNativeDetailsBaseForContainer.prototype);
                break;
            case "SecurityFindingNativeDetailsForDockle":
                Object.setPrototypeOf(obj, models.SecurityFindingNativeDetailsForDockle.prototype);
                break;
            case "SecurityFindingNativeDetailsForHadolint":
                Object.setPrototypeOf(obj, models.SecurityFindingNativeDetailsForHadolint.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof SecurityFindingNativeDetailsBase)[] {
        return [
            models.SecurityFindingNativeDetailsBaseForCloud,
            models.SecurityFindingNativeDetailsBaseForContainer,
            models.SecurityFindingNativeDetailsForDockle,
            models.SecurityFindingNativeDetailsForHadolint,
        ];
    }

    fixupFields() {
    }

}
